/**
 * JSON parse with error handling.
 *
 * @param {string} data - The data to be parsed.
 *
 * @returns {object|array|string|number|boolean|null}
 * @throws {SyntaxError} Thrown if the string to parse is not valid JSON.
 */
export function decodeJson(data) {
	try {
		return JSON.parse(data);
	} catch (e) {
		console.error(`JSON.parse error: Invalid data type for ${data} as ${typeof data}.`);
	}

	return null;
}

/**
 * JSON stringify with error handling.
 *
 * @param {*} data - The data to be stringified.
 *
 * @returns {string|null}
 * @throws {TypeError} When the data contains a circular reference or a BigInt value is encountered.
 */
export function encodeJson(data) {
	try {
		return JSON.stringify(data);
	} catch (e) {
		console.error('JSON.stringify error:', e);
	}

	return null;
}
